import React from 'react'
import styles from './SelectedObjectTag.module.scss'
import { SelectedObjectTagProps } from './SelectedObjectTag.types'
import { IconButton } from 'components/common'
import { IconClose } from 'assets'

const SelectedObjectTagComponent = (props: SelectedObjectTagProps) => {
  const { object, onCloseClick } = props
  return (
    <div className={styles.tag}>
      <span>{object.name}</span>
      <IconButton
        icon={IconClose}
        className={styles.iconButton}
        svgProps={{ fill: styles.borderGrey, width: 15, height: 15 }}
        onClick={onCloseClick}
      />
    </div>
  )
}

const SelectedObjectTag = SelectedObjectTagComponent
export { SelectedObjectTag }
